import api from '../libs/axios';

export const getInterestList = async (params, signal) => {
  const response = await api.get('/interrest', { params, signal });
  return response.data;
};
